import React, { useState } from "react";
import Image from "next/image";
import Placeholder from "../public/blueplaceholder.jpg";

interface Props {
  nodeOfInterest: any;
  graphData: any;
  setNodeOfInterest: any;
  edgeOutboundConnections: any;
  edgeInboundConnections: any;
  populateNodeInfo: any;
  setGraphData: any;
  setModalOption: any;
  graphStatistics: any;
}

export const NodeModule: React.FC<Props> = ({
  nodeOfInterest,
  graphData,
  setNodeOfInterest,
  edgeOutboundConnections,
  edgeInboundConnections,
  populateNodeInfo,
  setGraphData,
  setModalOption,
  graphStatistics,
}) => {
  const [isEditing, setEditing] = useState<boolean>(false);
  const [isDeleting, setIsDeleting] = useState<boolean>(false);
  const [connections, setConnection] = useState<any>([]);

  const saveNodeInfo = async (nodeToChange: any) => {
    let edgeArray: any = [];
    let nodesArray: any = graphData.nodes;
    let validConnections: any = Array.from(new Set(connections));

    nodesArray[nodeToChange.index] = nodeToChange;

    for (let i = 0; i <= validConnections.length; i++) {
      if (
        validConnections[i] !== nodeToChange.index &&
        nodesArray[validConnections[i]] !== undefined &&
        nodesArray[nodeToChange.index] !== undefined
      ) {
        edgeArray.push({
          source: nodesArray[nodeToChange.index],
          target: nodesArray[validConnections[i]],
        });
      }
    }

    setGraphData({
      ...graphData,
      nodes: nodesArray,
      links: graphData.links.concat(edgeArray),
    });
    setConnection([]);
    alert(
      "Successfully saved changes 🥳 - Remember to save the whole project once you are finished.  "
    );
  };

  const deleteSpecificNode = (id: number) => {
    let remainingNodes = graphData["nodes"].filter((obj: any) => obj.id !== id);
    let edgesLeft: any = graphData["links"].filter(
      (obj: any) => obj.source.id !== id && obj.target.id !== id
    );

    setGraphData({ links: edgesLeft, nodes: remainingNodes });
    setNodeOfInterest(null);
    setModalOption("General Information");
  };

  const deleteNode = () => {
    let nodesArray = graphData["nodes"];

    nodesArray.splice(Math.floor(Math.random() * nodesArray.length), 1);

    setGraphData({ ...graphData, nodes: nodesArray });
  };

  return (
    <div className="p-4">
      <div className="">
        <div className="grid grid-cols-6 my-2">
          <button
            onClick={() => setModalOption("General Information")}
            className="col-span-1 w-5/6 hover:cursor-pointer  hover:bg-blue-600 bg-blue-500 rounded-lg  text-white shadow-md py-1 px-4 flex flex-row font-semibold text-center  justify-center items-center space-x-1 "
          >
            {" "}
            Back
          </button>

          <div className="font-bold text-lg col-span-4 text-center text-ellipsis overflow-hidden  ">
            {nodeOfInterest.name || `Id ${nodeOfInterest.id}`}
          </div>
          <button
            onClick={() => setEditing(!isEditing)}
            className="col-span-1   hover:cursor-pointer  hover:bg-blue-600 bg-blue-500 rounded-lg  text-white shadow-md py-1 px-3 flex flex-row font-semibold text-center  justify-center items-center space-x-1 "
          >
            {" "}
            {!isEditing ? "Edit" : "Back"}
          </button>
        </div>
        {!isEditing ? (
          <div className="items-center place-content-center text-center ">
            <Image
              src={Placeholder}
              id={nodeOfInterest.id}
              width={64}
              height={64}
              alt={nodeOfInterest.name}
              className="fill m-2 rounded-full shadow-lg border-1  h-32 w-32 "
            />
            <div className="flex flex-row justify-between">
              <label className="block text-sm font-bold ">Node Name:</label>
              <p className="text-gray-700 text-sm">
                {nodeOfInterest.name || "Unnamed Node"}
              </p>
            </div>
            <div className="flex flex-row justify-between">
              <label className="block text-sm font-bold ">Cluster Group:</label>
              <p className="text-gray-700 text-sm">
                {nodeOfInterest.group || "Undefined"}
              </p>
            </div>
            <div className="flex flex-row justify-between">
              <label className="block text-sm font-bold ">Node Id:</label>
              <p className="text-gray-700 text-sm">{nodeOfInterest.id}</p>
            </div>
            <div className="w-full">
              <div className="w-full">
                <label className=" text-sm font-bold text-left w-full float-left">
                  Desciption:
                </label>
              </div>
              <div className="rows-span-1 max-h-30 ">
                <p className="text-gray-700 text-sm text-left">
                  {nodeOfInterest.description || "No Description"}
                </p>
              </div>
            </div>
            <hr className="my-2" />
            {edgeOutboundConnections.length >= 1 && (
              <div>
                <div className="flex flex-row justify-between">
                  <label className="block text-sm font-bold ">
                    Outbound Connections
                  </label>
                </div>
                <div className="flex flex-row justify-between">
                  <label className="block text-sm font-bold ">Number #:</label>
                  <p className="text-gray-700  text-sm">
                    {edgeOutboundConnections.length}
                  </p>
                </div>
                <div className="flex flex-row justify-between">
                  <label className="block text-sm font-bold ">Of Total:</label>
                  <p className="text-gray-700  text-sm">
                    {(
                      (edgeOutboundConnections.length /
                        graphStatistics["Total Nodes"]) *
                      100
                    ).toFixed(3)}
                    %
                  </p>
                </div>
                <div className="h-28 overflow-y-auto">
                  {edgeOutboundConnections?.map(
                    (connectedNode: any, key: any) => (
                      <div
                        key={key}
                        className=" py-1 px-3  hover:bg-blue-600 bg-blue-500 rounded-lg  text-white shadow-md border-b-2 border-gray-300 flex flex-row hover:cursor-pointer  p-1"
                        onClick={() =>
                          populateNodeInfo(connectedNode, graphData)
                        }
                      >
                        <p className="text-center w-full max-h-md">
                          {connectedNode.name || connectedNode.id}
                        </p>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}
            {edgeInboundConnections.length >= 1 && (
              <div>
                <div className="flex flex-row justify-between">
                  <label className="block text-sm font-bold ">
                    Inbound Connections
                  </label>
                </div>
                <div className="flex flex-row justify-between">
                  <label className="block text-sm font-bold ">Number #:</label>
                  <p className="text-gray-700  text-sm">
                    {edgeInboundConnections.length}
                  </p>
                </div>
                <div className="flex flex-row justify-between">
                  <label className="block text-sm font-bold ">Of Total:</label>
                  <p className="text-gray-700  text-sm">
                    {(
                      (edgeInboundConnections.length /
                        graphStatistics["Total Nodes"]) *
                      100
                    ).toFixed(3)}
                    %
                  </p>
                </div>
                <div className="h-28 overflow-y-auto">
                  {edgeInboundConnections?.map(
                    (connectedNode: any, key: any) => (
                      <div
                        key={key}
                        className=" py-1 px-3  hover:bg-blue-600 bg-blue-500 rounded-lg  text-white shadow-md border-b-2 border-gray-300 flex flex-row hover:cursor-pointer  p-1"
                        onClick={() =>
                          populateNodeInfo(connectedNode, graphData)
                        }
                      >
                        <p className="text-center w-full max-h-md">
                          {connectedNode.name || connectedNode.id}
                        </p>
                      </div>
                    )
                  )}
                </div>
              </div>
            )}

            <div>
              <div className="flex flex-row justify-between">
                <label className="block text-sm font-bold ">Total</label>
              </div>
              <div className="flex flex-row justify-between">
                <label className="block text-sm font-bold ">Number #:</label>
                <p className="text-gray-700  text-sm">
                  {edgeInboundConnections.length +
                    edgeOutboundConnections.length}
                </p>
              </div>
              <div className="flex flex-row justify-between">
                <label className="block text-sm font-bold ">Of Total:</label>
                <p className="text-gray-700  text-sm">
                  {(
                    ((edgeInboundConnections.length +
                      edgeOutboundConnections.length) /
                      graphStatistics["Total Nodes"]) *
                    100
                  ).toFixed(3)}
                  %
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="flex flex-col">
              <label className="text-sm font-medium ml-2  float-left">
                {" "}
                Name
              </label>
              <input
                value={nodeOfInterest.name}
                className="border-0 px-3 py-3 m-1 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                placeholder={"Add/Change Node Name"}
                onChange={(e) =>
                  setNodeOfInterest({
                    ...nodeOfInterest,
                    name: e.target.value,
                  })
                }
              ></input>
              <label className="text-sm font-medium ml-2 my-2">
                {" "}
                Description
              </label>
              <form>
                <textarea
                  id="editor"
                  rows={15}
                  onChange={(e) =>
                    setNodeOfInterest({
                      ...nodeOfInterest,
                      description: e.target.value,
                    })
                  }
                  maxLength={2000}
                  value={
                    nodeOfInterest.description !== "" ||
                    nodeOfInterest.desciption !== undefined
                      ? nodeOfInterest.description
                      : ""
                  }
                  placeholder={"Node Information goes here"}
                  className="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full ease-linear transition-all duration-150"
                ></textarea>
              </form>
            </div>
            <form className="my-1">
              <label
                className="block text-xs font-bold mb-2"
                htmlFor="grid-password"
              >
                Add Connections To:
              </label>

              <select
                name="select"
                id="select icon"
                onChange={(e) => connections.push(parseInt(e.target.value))}
                className=" px-3 py-3 hover:cursor-pointer  form-select appearance-none block w-full hover:bg-gray-200 text-base font-normal text-gray-700 bg-white bg-clip-padding bg-no-repeat border border-solid border-gray-300 rounded transition ease-in-out m-0 focus:text-gray-700 focus:bg-white focus:border-blue-800 focus:outline-none"
              >
                {graphData.nodes?.map((node: any, key: string) => (
                  <option key={key} value={node.id}>
                    Id: {node.id} ({node.name})
                  </option>
                ))}
              </select>
            </form>
            {connections.map((num: any, key: string) => (
              <p className="float-left m-2" key={key}>
                {num}
              </p>
            ))}
            <button
              onClick={() => saveNodeInfo(nodeOfInterest)}
              className="my-2 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full "
            >
              Save Edits
            </button>
            <div className="flex flew-row justify-between ">
              <button
                onClick={() => setIsDeleting(!isDeleting)}
                className="my-2 bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full "
              >
                {" "}
                Delete Node
              </button>
            </div>
            {isDeleting && (
              <div>
                {" "}
                <p className="text-sm font-semibold text-center">
                  Are you sure? Once you delete you can&apos;t get your node
                  back.
                </p>
                <div className="flex flew-row justify-between m-2">
                  <button
                    onClick={() => setIsDeleting(!isDeleting)}
                    className="m-2 bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full "
                  >
                    {" "}
                    No
                  </button>
                  <button
                    onClick={() => deleteSpecificNode(nodeOfInterest.id)}
                    className="m-2 bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline w-full "
                  >
                    {" "}
                    Yes
                  </button>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};
